import { useNavigate, useSearchParams } from "react-router-dom";

import Button from "../../ButtonComponent";
import HeaderModule from "../../ModuleHeaderComponent";

import RightChevron from "../../../../../../src/assets/images/chevron-left-color.svg";

import { useSaveInclusiveContent } from "../mutation"

import { BUTTON_VARIANTS } from "../../constant";

import { ASSESSMENT_ALLOWED, CHAPTER_COMPLETE_PERCENTAGE, POST_CHAPTER_ASSESSMENT } from "../../../../../utils/cookiesmanager";

import styles from "./styles.module.scss";
import { toast, ToastContainer } from "react-toastify";

const InclusiveEducation = (props) => {
  const { inclusiveEducationContent, isLoading , handleBackClick , setShowShowInclusiveContent } = props;

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const courseId = searchParams.get("courseId");
  const moduleId = searchParams.get("moduleId");
  const courseName = searchParams.get("courseName");
  const chapterId = searchParams.get("chapterId");
  const chapterPercentage = localStorage.getItem(CHAPTER_COMPLETE_PERCENTAGE);
  const chapterPostAssessment = Number(localStorage.getItem(POST_CHAPTER_ASSESSMENT));

  if (isLoading) {
    <div>Loading...</div>;
  }

  const { data: inclusiveEducationContentData } =
    inclusiveEducationContent || {};

  const { response } = inclusiveEducationContentData || {};

  const textData = response?.texts?.[0];

  const videoData = response?.videos?.[0];

  const videoStatus = videoData?.videoStatus;

  const { mutate: saveProgress , isPending } = useSaveInclusiveContent();

  const totalParts = response?.totalContent;

  const handlePrevious = () => {
  setShowShowInclusiveContent(false)
  }

  const handleclick = () => {
    if(videoStatus === 1 && chapterPercentage === '100%'){
      navigate(`/user/chapter-list?${searchParams.toString()}`)
      return;
    }

    saveProgress(
      {
        courseId,
        moduleId,
        chapterId,
        totalParts: totalParts || 1,
        part: totalParts === 1 ? 1 : 2,
      },
      {
        onSuccess: () => {
          /**
           * If Chapter has no post assessment Then navigate to chapter list page.
           * 0 means no assessment and 1 means assessment is there for the chapter.
           */
          if(chapterPostAssessment === 0){
          toast.error("No assessment for this chapter.")
          setTimeout(() => {
            navigate(`/user/chapter-list?${searchParams.toString()}`);
        }, 2000);
        return;
          }

          sessionStorage.setItem(ASSESSMENT_ALLOWED, "true");
          navigate(
            `/user/post-chapter-assessment?courseId=${courseId}&moduleId=${moduleId}&chapterId=${chapterId}&courseName=${courseName}`,
          );
        },
        onError: (error) => {
          console.error("Progress update failed", error);
        },
      },
    );
  };

  return (
    <>
      <HeaderModule
        title={textData?.title}
        className={styles["header-title"]}
        onBackClick={handleBackClick}
      />

      <div className={styles["container-top"]}>
        <div className={styles["content-wrapper"]}>
          <div
            className={styles["title-text"]}
            dangerouslySetInnerHTML={{ __html: textData?.text || "" }}
          />
        </div>
      </div>

      <div className={styles["bottom-wrapper"]}>
                <Button
          label="Previous"
          buttonVariant={BUTTON_VARIANTS.SECONDARY}
          className={styles["button-class"]}
          onClick={handlePrevious}
          startIcon={
            <img
              className={styles["left-chevron"]}
              src={RightChevron}
              alt="chevron"
            />
          }
        />
        <Button
          label={(videoStatus === 1 && chapterPercentage === '100%') ? 'Back To chapter' :"Start Assessment"}
          buttonVariant={BUTTON_VARIANTS.PRIMARY}
          className={styles["button-class"]}
          onClick={handleclick}
          disabled={isPending}
        />
        <ToastContainer/>
      </div>
    </>
  );
};

export default InclusiveEducation;
